import { render } from "./nano.vue?vue&type=template&id=c1896a18&scoped=true"
const script = {}

import "./nano.vue?vue&type=style&index=0&id=c1896a18&scoped=true&lang=css"

import exportComponent from "/var/www/html/resources/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1896a18"]])

export default __exports__